import React from "react";
import StockItemCard from "./StockItemCard";
import CarItemList from "./StockItemList";

function renderStockCards(stock) {
  return stock.DealershipID[0] === "MT006" ? (
    <StockItemCard key={stock.ID} stock={stock} />
  ) : null;
}

function renderStockList(stock) {
  return stock.DealershipID[0] === "MT006" ? (
    <CarItemList key={stock.ID} stock={stock} />
  ) : null;
}

const StockList = (props) => {
  if (props.displayType === "cards")
    return <div>{props.stocklist.map((stock) => renderStockCards(stock))}</div>;
  else if (props.displayType === "list")
    return <div>{props.stocklist.map((stock) => renderStockList(stock))}</div>;

  // Removed the console.log statement here
};

export default StockList;
